import { HttpEventType, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Injector, inject } from '@angular/core';
import { tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RESOLVED_TENANT_HEADER, TENANT_HEADER, TenantService, readTabTenant } from '../services/tenant.service';

const apiOrigin = (() => {
  try {
    return new URL(environment.endpoints.users.uri).origin;
  } catch {
    return '';
  }
})();

const isApiRequest = (url: string) => !!apiOrigin && url.startsWith(apiOrigin);

/**
 * Sends the tab-pinned tenant with every API call and keeps the pin in sync
 * with the tenant the API resolved.
 */
export const TenantHeaderInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  if (!isApiRequest(req.url)) {
    return next(req);
  }

  const injector = inject(Injector);
  const tenantId = readTabTenant();
  if (tenantId && !req.headers.has(TENANT_HEADER)) {
    req = req.clone({ headers: req.headers.set(TENANT_HEADER, tenantId) });
  }

  return next(req).pipe(
    tap((event) => {
      if (event.type !== HttpEventType.Response || !tenantId) return;
      const resolved = event.headers.get(RESOLVED_TENANT_HEADER);
      if (resolved && resolved !== tenantId) {
        injector.get(TenantService).syncResolvedTenant(resolved);
      }
    })
  );
};
